import Default from './Default';
import Article from './Article';

const getShareTipsContent = (type) => {
  switch (type) {
    case 'article':
      return Article();
    case 'default':
    default:
      return Default();
  }
};

export default getShareTipsContent;
